import React, { useEffect, useState } from "react";
import { Link, Outlet, useParams } from "react-router-dom";
import { API } from "../config/api.js";
import { get } from "../lib/http.js";

export default function ApprovedEventRoute() {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, event: null, error: "" });

  useEffect(() => {
    let active = true;
    get(`${API.events.getSinglEvent}/${id}`)
      .then((response) => {
        if (active) setState({ loading: false, event: response?.event || response, error: "" });
      })
      .catch((error) => {
        if (active) setState({ loading: false, event: null, error: error.message || "Could not verify event status." });
      });
    return () => { active = false; };
  }, [id]);

  if (state.loading) {
    return <div className="h-56 animate-pulse rounded-2xl bg-slate-100" aria-label="Checking event approval" />;
  }

  const approved = String(state.event?.approvalStatus || "approved").toLowerCase() === "approved";
  if (!approved) {
    const rejected = String(state.event?.approvalStatus || "").toLowerCase() === "rejected";
    return (
      <div className="mx-auto max-w-xl rounded-2xl border border-amber-200 bg-white p-7 text-center shadow-sm">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-amber-100 text-xl">{rejected ? "!" : "⌛"}</div>
        <h1 className="mt-4 text-2xl font-black text-slate-900">
          {state.error ? "Dashboard unavailable" : rejected ? "Event needs changes" : "Approval is pending"}
        </h1>
        <p className="mt-2 text-sm leading-6 text-slate-600">
          {state.error || (rejected
            ? state.event?.rejectionReason || "Review the event feedback before resubmitting."
            : "Analytics and booking tools unlock after your event is approved.")}
        </p>
        <Link to="/listyourshow/manage" className="mt-6 inline-flex rounded-full bg-slate-900 px-5 py-2.5 text-sm font-bold text-white hover:bg-amber-600">
          Back to my events
        </Link>
      </div>
    );
  }

  return <Outlet />;
}
